import React from "react";
import BrowsePros from "./BrowsePros";
import { isProTeam } from "../../../utils";
import { useUser } from "../../../hooks/useUser";
import { Link } from "react-router-dom";
import { matchPath } from "react-router";
import { PageTitle } from "../../../components/PageTitle";
import { ReactComponent as AddIcon } from "../../../assets/svg/add-icon.svg";
import { MainContainer } from "../../../components/ContentWrapper";
import { DropdownMenu } from '../../../components/Dropdown/Dropdown'
import { MenuIcon } from "../../../components/MenuOptions/MenuIcon";


export default function ProListing() {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const { role } = useUser();
  const [showDialog, setShowDialog] = React.useState(false);

  const isSharePath = matchPath(
    {
      path: "/experts/share",
      exact: false,
      strict: false,
    },
    location.pathname
  );

  // const [shortlists, setShortlists] = useState([]);
  // const [selectedShortlistId, setSelectedShortlistId] = useState(null);

  // const fetchShortlists = async (query = "") => {
  //   try {
  //     const response = await axiosInstant.get("/shortlists", {
  //       params: { search: query },
  //     });
  //     setShortlists(response.data || []);
  //   } catch (error) {
  //     console.error("Error fetching shortlists:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchShortlists();
  // }, []);

  return (
    <MainContainer>
      <div className="flex justify-between items-center gap-3 flex-wrap">
        <PageTitle title="Experts" />
        <div className="flex items-center gap-2">
          {isProTeam(role) && !isSharePath && (
            <Link to="/experts/create" className="shrink-0">
              <div className="flex items-center gap-1 bg-primary text-sm sm:text-base text-white py-2.5 sm:py-3 px-4 sm:px-5 lg:px-10 cursor-pointer rounded-xl focus:outline-none focus:shadow-outline whitespace-nowrap">
                <AddIcon className="mr-1" />
                Create Profile
              </div>
            </Link>
          )}

          <DropdownMenu
            trigger={<MenuIcon id="export-menu" isDetailedPage />}
            options={[
              {
                label: 'Export CSV',
                onClick: () => setShowDialog(true),
              },
            ]}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          />
        </div>
      </div>
      <BrowsePros
        isSharePath={!!isSharePath}
        showDialog={showDialog}
        setShowDialog={setShowDialog}
        showShortlistFilter={true}
        isExpertPage={true}
        isShortlistPage={false}
      />
    </MainContainer>
  );
}
